// Core
import React, { Component } from 'react';

export class KeyDownListener extends Component {
    static defaultProps = {
        onEsc: () => { },
        onAny: () => {},
    };

    componentDidMount () {
        document.addEventListener('keydown', this.onKeyDown);
    }

    componentWillUnmount () {
        document.removeEventListener('keydown', this.onKeyDown);
    }

    onKeyDown = ({ key }) => {
        const { onEsc, onAny } = this.props;

        switch (key) {
            case 'Escape':
                onEsc();
                break;
            default:
                onAny(key);
        }
    };

    render () {
        return (
            <span />
        );
    }
}
